import React from 'react';

// import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Collapse from '@material-ui/core/Collapse';
import Alert from '@material-ui/lab/Alert';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Box from '@material-ui/core/Box';

// const useStyles = makeStyles((theme) => ({
//   alertfooter: {
//     position: 'sticky',
//     bottom: 0,
//     left: 0,
//     right: 0,
//     marginTop: theme.spacing(4),
//     [theme.breakpoints.down('xs')]: {
//       position: 'inherit',
//     },
//   },
// }));

export default function AlertFooter(props) {
  const [open, setOpen] = React.useState(true);
  // const classes = useStyles();
  return (
    <Box width={1} height={1} position='absolute' className='no-print'>
      <Container maxWidth='lg'>
        <Collapse in={open}>
          <Alert
            color='warning'
            icon={false}
            action={
              <IconButton
                aria-label='close'
                color='inherit'
                size='small'
                onClick={() => {
                  setOpen(false);
                }}
              >
                <CloseIcon fontSize='inherit' className='no-print' />
              </IconButton>
            }
            onClose={() => {}}
          >
            <span>
              <div dangerouslySetInnerHTML={{ __html: props.info }} />
            </span>
          </Alert>
        </Collapse>
      </Container>
    </Box>
  );
}
